<div class="antipasti-menu" tabindex="0" role="button" (click)="goToProductPage()"> 

<article class="food-card">
  <img
    loading="lazy"
    src="{{item.immagine_principale}}"
    class="food-image"
  />
  <div class="food-details">
    <div class="food-info">
      <h2 class="food-title">{{item.descart}}</h2>
      <div class="allergens-strip" *ngIf="item.ingredienti?.length">
        <ng-container *ngFor="let ingredient of item.ingredienti">
          <ng-container *ngFor="let dato of ingredient.dati">
            <img
              class="allergen-icon"
              [src]="dato.icona"
              [alt]="dato.descrizione"
              loading="lazy"
            />
          </ng-container>
        </ng-container>
      </div>
    </div>
    
    <div class="price-container" >
      <span class="currency-symbol">€</span>
      <span class="price-value" >{{ item.prezzo | number:'1.2-2'}}</span>
    </div>
  </div>
</article> 
</div>